// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__12CpZ","col":"CardReaderDesc_col__3dogp","label":"CardReaderDesc_label__1fonQ"};